import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';

// Wraps the whole DashboardLayout tree — bounces to /login if there's no admin session,
// and remembers the page the user was trying to reach so login can send them back.
export default function AuthGuard({ children }) {
  const { isLoggedIn, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized) return <Loader />;

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return children;
}

AuthGuard.propTypes = { children: PropTypes.node };
